"use client";

import React from 'react';
import Image from 'next/image';

interface CarouselProps {
  items: Array<{
    id: string;
    name: string;
    logo?: string;
    placeholder?: string;
  }>;
  className?: string;
}

export default function PartnerCarousel({ items, className = "" }: CarouselProps) {
  // Duplicate items for seamless infinite scroll
  const duplicatedItems = [...items, ...items];

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Gradient overlays for fade effect */}
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none"></div>
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none"></div>
      
      <div className="flex animate-scroll">
        {duplicatedItems.map((item, index) => (
          <div
            key={`${item.id}-${index}`}
            className="flex-shrink-0 mx-6 flex items-center justify-center"
            style={{ minWidth: '180px' }}
          >
            {item.logo ? (
              <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
                <Image
                  src={item.logo}
                  alt={item.name}
                  width={140}
                  height={70}
                  className="object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ) : (
              <div className="bg-gray-100 h-16 w-36 rounded-lg flex items-center justify-center opacity-60 hover:opacity-80 hover:bg-gray-200 transition-all duration-300 border border-gray-200">
                <span className="text-gray-600 text-sm font-medium">{item.placeholder || item.name}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
